// Определить ширину солонки
function stCol(width, i) {
	const w = width[i]
	const st = w ? {width: w} : {}
	return st
}

export {stCol}
